export const TOAST_SEVERITY_TYPES = {
    SUCCESS: "success", 
    INFO: "info", 
    WARNING: "warn",
    ERROR: "error"
} as const;